import PropTypes from "prop-types";
import { nanoid } from "nanoid";
import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { HTMLContent } from "./Content";
export default function Testimonials(props) {
  let {
    testimonials,
    pageTestimonials,
    testimonialWordCount = 30,
    showSlider = true,
    slideCount = 10,
    slideMode = "random",
    slideFeatured = false,
    showIndicators = false,
  } = props;

  let stars = [];
  stars[5] = <>&#11088;&#11088;&#11088;&#11088;&#11088;</>;
  stars[4] = <>&#11088;&#11088;&#11088;&#11088</>;
  stars[3] = <>&#11088;&#11088;&#11088</>;
  stars[2] = <>&#11088;&#11088;</>;
  stars[1] = <>&#11088;</>;

  if (
    pageTestimonials &&
    pageTestimonials.testimonial &&
    pageTestimonials.testimonial.length
  ) {
    if (pageTestimonials.testimonial.length === 1) {
      return (
        <>
          <div>
            <div className="testimonial-carousel content">
              <div className="content p-2">
                <div className="content box">
                  <p className="testimonial is-size-6 has-text-weight-normal has-text-left">
                    <HTMLContent
                      content={pageTestimonials.testimonial[0].review}
                    />
                  </p>
                  <p className="testimonial is-size-6 has-text-weight-normal has-text-right">
                    {pageTestimonials.testimonial[0].name.toUpperLowerCase()}
                    <br />
                    {stars[pageTestimonials.testimonial[0].rating]}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    } else {
      testimonials = [];
      pageTestimonials.testimonial.forEach((edge) => {
        testimonials.push({ node: edge });
      });
      //console.log(testimonials);
    }
  }

  // remove all testimonials that are too short
  let filteredTestimonials;

  if (!testimonials) return null;
  if (testimonials.length) {
    filteredTestimonials = testimonials.filter(
      (testimonial) =>
        testimonial.node.review &&
        testimonial.node.review.split(" ").length >= testimonialWordCount
    );
  }

  let slideTestimonials = [...filteredTestimonials];

  if (showSlider && slideTestimonials.length) {
    // filter templates down to featured

    if (slideFeatured) {
      slideTestimonials = slideTestimonials.filter(
        (testimonial) => testimonial.node.rating === 5
      );
    }

    // randomize testimonials

    if (slideMode === "random") {
      slideTestimonials = shuffle(slideTestimonials);
    }

    // limit testimonials to slideCount

    if (slideCount) {
      slideTestimonials = slideTestimonials.slice(0, slideCount);
    }
  }
  let imageLink = false;
  //console.log(slideTestimonials);
  return (
    <>
      {showSlider && slideTestimonials.length ? (
        <div>
          <div className="testimonial-carousel content">
            <Carousel
              showArrows={true}
              infiniteLoop={true}
              showThumbs={false}
              showStatus={false}
              autoPlay={true}
              interval={7500}
              showIndicators={showIndicators}
            >
              {slideTestimonials.map((testimonial) => {
                //let imageLink = testimonial.node.user.thumbnail.split("=")[0];

                return (
                  <div key={nanoid()}>
                    <div className="content p-2">
                      <div className="content box">
                        {false && testimonial.node.thumbnail ? (
                          <img
                            src={imageLink}
                            alt={testimonial.node.name}
                            className="is-256x256 "
                            style={{ width: "256px" }}
                          />
                        ) : null}
                        <p className="testimonial is-size-6 has-text-weight-normal has-text-left">
                          <HTMLContent content={testimonial.node.review} />
                        </p>
                        <p className="testimonial is-size-6 has-text-weight-normal has-text-right">
                          &mdash; {testimonial.node.name.toUpperLowerCase()}
                          <br />
                          {stars[testimonial.node.rating]}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Carousel>
          </div>
        </div>
      ) : null}

      <div className="content">
        <ul className="testimonial-list no-bullets">
          {filteredTestimonials.length
            ? filteredTestimonials.map((testimonial) => {
                let imageBlock = false;

                if (testimonial.node.images) {
                  let imageBlockArray = [];
                  testimonial.node.images.forEach((image) => {
                    let imageLink = image.split("=")[0];

                    imageBlockArray.push(
                      <a href={imageLink}>
                        <img
                          alt="Testimonial Image"
                          src={image}
                          style={{ width: "128px" }}
                          className="is-128x128 ml-2 mb-2"
                        />
                      </a>
                    );
                  });
                  imageBlock = [...imageBlockArray];
                }

                //let imageLink = testimonial.node.thumbnail.split("=")[0];
                let imageLink = false;
                if (testimonial.node.snippet) {
                  return (
                    <li key={nanoid()}>
                      {false && testimonial.node.thumbnail ? (
                        <img
                          src={imageLink}
                          alt={testimonial.node.name}
                          className="is-128x128 ml-4 pb-4 "
                          style={{ width: "128px", float: "right" }}
                        />
                      ) : null}

                      {imageBlock ? (
                        <div
                          style={{ height: "128px", float: "left" }}
                          className="pr-4 mb-4 is-hidden-mobile"
                        >
                          {imageBlock}
                        </div>
                      ) : null}
                      <div className="testimonial is-size-6 has-text-weight-normal is-family-primary">
                        "
                        <HTMLContent content={testimonial.node.review} />"
                        <div className="has-text-right">
                          <br clear="all" />
                          <h5 className="testimonial-author is-size-6 has-text-weight-normal  pt-0 mt-0 pb-0 mb-0">
                            &mdash; {testimonial.node.user.name},<br />
                            {testimonial.node.date}
                          </h5>
                          <h6 className="testimonial-author is-size-6 has-text-weight-normal  pt-0 mt-0">
                            {" "}
                            {stars[testimonial.node.rating]}
                          </h6>
                        </div>
                      </div>

                      <br clear="all" />
                      <hr className="gray" />
                    </li>
                  );
                } else {
                  return <></>;
                }
              })
            : null}
        </ul>
      </div>
    </>
  );
}

Testimonials.propTypes = {
  testimonials: PropTypes.array,
  showSlider: PropTypes.bool,
  slideCount: PropTypes.number,
  slideMode: PropTypes.string,
};

function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}
String.prototype.toUpperLowerCase = function () {
  var string = this.split("");
  string[0] = string[0].toUpperCase();
  return string.join("");
};
String.prototype.firstUpper = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};
